"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = void 0;
var spacing = exports.spacing = function spacing(factor) {
  return "".concat(0.25 * factor, "rem");
};